import {
    CARTPRODUCTADD,
    CARTPRODUCTREMOVE,
    CARTQTYDECREMENT,
    CARTQTYINCREMENT
} from "./actionTypes";

const initialState = [];

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case CARTPRODUCTADD: {
      const searchProduct = state.find(
        (product) => product.id === action.product.id
      );

      if (searchProduct) {
        const updateState = state.map((product) => {
          if (product.id === searchProduct.id) {
            return { ...product, quantity: product.quantity + 1 };
          }
          return { ...product };
        });
        return updateState;
      } else {
        const updateState = [...state, action.product];
        return updateState;
      }
    }
    case CARTPRODUCTREMOVE: {
      const updateState = state.filter((product) => {
        if (product.id !== action.id) return { ...product };
      });
      return updateState;
    }
    case CARTQTYINCREMENT: {
      const updateState = state.map((product) => {
        if (product.id === action.id) {
          return { ...product, quantity: product.quantity + action.value };
        }
        return { ...product };
      });
      return updateState;
    }
    case CARTQTYDECREMENT: {
      const updateState = state.map((product) => {
        if (product.id === action.id) {
          return { ...product, quantity: product.quantity - action.value };
        }
        return { ...product };
      });
      return updateState;
    }
    default:
      return state;
  }
};

export default cartReducer;
